import PropTypes from 'prop-types';
import postCodeAnywhereLocation from '../external/postCodeAnywhereLocation';

const assignmentLocation = PropTypes.shape({
  title: PropTypes.string.isRequired,
  activitiesSummary: PropTypes.string.isRequired,
  description: PropTypes.string,
  id: PropTypes.number.isRequired,
  startDate: PropTypes.string.isRequired,
  activitiesTotalDuration: PropTypes.number.isRequired,
  location: postCodeAnywhereLocation.isRequired,
});

export default assignmentLocation;
